export default "__VITE_ASSET__Bs$FEfRM__"